import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import "./DeleteRule.css";

function DeleteRule() {
  const [name, setName] = useState();
  const [period, setPeriod] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  let { rid } = useParams();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/rules/${rid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setName(response.data.rule.title);
      setPeriod(response.data.rule.periodId);
    }
    fetch();
    setIsLoading(false);
  }, []);

  const handleSubmit = async () => {
    try {
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_BACKEND_URL}/rules/${rid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate(`/evaluations/rules/${period}`);
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Col className="delete-rule">
            <Col>
              <h4>{t("Evaluaciones.Reglas.DeleteRule.Titulo")}</h4>
            </Col>
            <Col className="delete-rule-form">
              <Col className="mb-1">
                <p>{t("Evaluaciones.Reglas.DeleteRule.Pregunta")}</p>
              </Col>
              <Col>
                <Button className="primary" onClick={handleSubmit}>
                  {t("Evaluaciones.Reglas.DeleteRule.Eliminar")}
                </Button>
                <Button
                  className="danger"
                  onClick={() => navigate(`/evaluations/rules/${period}`)}
                >
                  {t("Evaluaciones.Reglas.DeleteRule.Cancelar")}
                </Button>
              </Col>
            </Col>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default DeleteRule;
